"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var diveEnums_1 = require("@dive/enums/diveEnums");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageBullets_sidecar_1 = require("@voyage/entities/voyageBullets-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.BulletCreate;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.bulletId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.firedCrewId);
    messageWriter_sidecar_1.messageWriter.write8(m, d.type);
    messageWriter_sidecar_1.messageWriter.write8(m, d.subtype);
    messageWriter_sidecar_1.messageWriter.write8(m, d.team);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.x);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.y);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.dx);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.dy);
    messageWriter_sidecar_1.messageWriter.writeFloat(m, d.rot);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        bulletId: messageWriter_sidecar_1.messageWriter.read32(m),
        firedCrewId: messageWriter_sidecar_1.messageWriter.read32(m),
        type: messageWriter_sidecar_1.messageWriter.read8(m),
        subtype: messageWriter_sidecar_1.messageWriter.read8(m),
        team: messageWriter_sidecar_1.messageWriter.read8(m),
        x: messageWriter_sidecar_1.messageWriter.readFloat(m),
        y: messageWriter_sidecar_1.messageWriter.readFloat(m),
        dx: messageWriter_sidecar_1.messageWriter.readFloat(m),
        dy: messageWriter_sidecar_1.messageWriter.readFloat(m),
        rot: messageWriter_sidecar_1.messageWriter.readFloat(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        bulletId: 100,
        firedCrewId: 123,
        type: diveEnums_1.EMessageBulletTeamType.Alien,
        subtype: diveEnums_1.EDiveBulletSubtype.Fireball,
        team: 1,
        x: 7,
        y: 8,
        dx: 123.123,
        dy: 32.234,
        rot: 34.1234,
    };
    messageWriter_sidecar_1.messageWriter.test('bullet-create', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    voyageBullets_sidecar_1.voyageBullets.create(msg);
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
